class ComandaGenerada {
    constructor(
        public id = 0,
        public id_proveidor = 0,
        public proveidor = "",
        public setmana = "",
        public inici = new Date(),
        public fin = new Date(),
        public estat = 0,
        public creacio = new Date(),
        public enviat = 0,
        public email = "",
        public revisada = 0,
        public generada = 0
    ) {
        this.id = id;
        this.id_proveidor = id_proveidor;
        this.proveidor = proveidor;
        this.setmana = setmana;
        this.inici = inici;
        this.fin = fin;
        this.estat = estat;
        this.creacio = creacio;
        this.enviat = enviat;
        this.email = email;
        this.revisada = revisada;
        this.generada = generada;
    }
}
export default ComandaGenerada;
